import { Button, Flex, Icon, Spinner, Text, VStack } from "@chakra-ui/react";
import { HiOutlinePlus } from "react-icons/hi2";
import { useEffect, useState } from "react";
import UserService from "@/services/UserService";
import UserListItem from "@/pages/users/components/UserListItem";
import CreateUserDrawer from "@/pages/users/components/CreateUserDrawer";
import EditUserDrawer from "@/pages/users/components/EditUserDrawer";

const UsersPage = () => {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [editUser, setEditUser] = useState(null);

    const loadUsers = () => {
        setIsLoading(true);
        UserService.getAll()
            .then(response => {
                setUsers(response.items)
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        loadUsers();
    }, []);

    if (isLoading) {
        return (
            <Flex w="full" py={24} alignItems="center" justifyContent="center">
                <Spinner size="xl" color="white" />
            </Flex>
        );
    }

    return (
        <VStack w="full" rowGap={6}>
            <Flex flexDirection="row" justifyContent="space-between" alignItems="center" w="full">
                <Text color="white" fontSize={24} fontWeight="semibold">Users</Text>
                <Button variant="primary" textDecoration="unset" onClick={() => setIsCreateOpen(true)}>
                    <Icon fontSize={46}><HiOutlinePlus /></Icon>
                    <Text>Add User</Text>
                </Button>
            </Flex>
            {users?.map((user) => (
                <UserListItem
                    key={user.id}
                    user={user}
                    onRefresh={loadUsers}
                    onEdit={setEditUser}
                />
            ))}
            <CreateUserDrawer
                isOpen={isCreateOpen}
                onClose={() => setIsCreateOpen(false)}
                onCreated={loadUsers}
            />
            <EditUserDrawer
                isOpen={!!editUser}
                onClose={() => setEditUser(null)}
                onSaved={loadUsers}
                user={editUser}
            />
        </VStack>
    );
};

export default UsersPage;
